import Types from './types';
import { createReducer } from 'reduxsauce';

const INITIAL_STATE = {
    country: '',
    email: '',
    mobilePhone: '',
    name: ' ',
    roles: [],
    sub: '',
};

const setUser = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        ...data,
    };
};

const HANDLERS = {
    [Types.SET_USER]: setUser
};

export default createReducer(INITIAL_STATE, HANDLERS);